/* cords2-gallery.js — one gallery per colour.

   Pressing a swatch swaps the whole set: product shots, lifestyle and
   packaging, all in the chosen colour. Every colour's frames are already in
   the DOM, hidden, so switching is attribute work and never a fetch.

   THAT LAST SENTENCE WAS HALF TRUE AND IT CAUSED A FLICKER. 15 October 2026,
   Viktor: the screen flickers when you change colour. Measured on Cylindric
   UX1: 29 frames, 22 hidden, 28 of them loading="lazy" and 28 not fetched.
   The markup was in the DOM; the pixels were not. A lazy image inside a
   hidden element is never fetched, so pressing a swatch unhid a set of empty
   boxes and the photographs popped in one by one as they arrived. Switching
   was attribute work, but the attribute work revealed nothing to look at.

   WARMING IS THE FIX, NOT EAGER MARKUP. Rendering all 29 eagerly would cost
   every visitor the whole catalogue on first paint, and most never touch the
   swatches. So the first frame of each colour is promoted to eager once the
   page is idle: four extra images on this product, chosen so that whichever
   swatch is pressed, the frame that appears is already there. The rest of a
   colour's frames are warmed when that colour is chosen, while the buyer is
   looking at the first one.

   The promotion is loading="eager" rather than a new Image() with the same
   src, because eager makes the browser run its own source selection against
   the srcset and sizes already on the element. Hand-building a URL would
   fetch a second, differently sized file and warm the wrong cache entry. A
   display:none image does fetch when it is eager; it is only lazy that
   skips it.

   INDEXES ARE NOT WRITTEN INTO THE MARKUP. The rail, the frames and the dots
   are generated from one loop in one order, so index n of each is the same
   photograph, and this script pairs them by DOM position. Numbering them in
   Liquid meant keeping three counters in step across three loops, which is
   the kind of thing that works until someone adds a condition to one of them.

   It owns the gallery outright. cords2-pdp.js used to swap the src of two
   fixed frames; those hooks are gone and its two image functions now find
   nothing and return, which is why it needed no edit. No load-order
   dependency either: this parses the variant JSON itself. */
(function () {
  var gal = document.querySelector('[data-c2-gal]');
  if (!gal) return;

  var track  = gal.querySelector('[data-c2-track]');
  var frames = Array.prototype.slice.call(gal.querySelectorAll('[data-c2-frame]'));
  var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-c2-thumb]'));
  var dots   = Array.prototype.slice.call(gal.querySelectorAll('[data-c2-dot]'));
  var prev   = gal.querySelector('[data-c2-step="-1"]');
  var next   = gal.querySelector('[data-c2-step="1"]');
  if (!frames.length) return;

  var colour = gal.getAttribute('data-c2-colour') || '';
  var at = 0;
  for (var a = 0; a < frames.length; a++) {
    if (frames[a].hasAttribute('data-c2-on')) { at = a; break; }
  }

  function phone() { return window.matchMedia('(max-width: 989px)').matches; }
  function inColour(el) { return el.getAttribute('data-c2-colour') === colour; }
  function group() { return frames.filter(inColour); }

  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1500); };

  /* Promote to eager so the browser fetches now, using the element's own
     srcset and sizes. Already-eager and already-loaded frames are skipped,
     so this is safe to call repeatedly. */
  function warm(list) {
    for (var i = 0; i < list.length; i++) {
      var im = list[i].querySelector('img');
      if (im && im.getAttribute('loading') === 'lazy') im.setAttribute('loading', 'eager');
    }
  }

  /* One frame per colour: whichever swatch is pressed, the frame that shows
     first is the one that is already there. */
  function leadFrames() {
    var seen = {}, out = [];
    for (var i = 0; i < frames.length; i++) {
      var c = frames[i].getAttribute('data-c2-colour');
      if (!c || seen[c]) continue;
      seen[c] = 1;
      out.push(frames[i]);
    }
    return out;
  }

  /* Geometry is cached and the scroll handler reads none of it live. The
     first version deferred to requestAnimationFrame, which is the usual
     advice and is wrong here: rAF does not run in a hidden tab, so a page
     restored mid-scroll kept its dots on the wrong frame. Rebuilt on resize,
     and whenever the colour changes, because the frames that were hidden
     measured zero. */
  var geo = [];
  function measure() {
    geo = frames.map(function (f) { return { l: f.offsetLeft, w: f.offsetWidth }; });
  }

  function show(i, scroll) {
    var list = group();
    if (!list.length) return;
    var frame = frames[i];
    if (!frame || !inColour(frame)) frame = list[0];
    at = frames.indexOf(frame);

    for (var n = 0; n < frames.length; n++) {
      if (n === at) { frames[n].setAttribute('data-c2-on', ''); }
      else { frames[n].removeAttribute('data-c2-on'); }
      if (thumbs[n]) thumbs[n].setAttribute('aria-selected', String(n === at));
      if (dots[n]) dots[n].setAttribute('aria-selected', String(n === at));
    }

    var many = list.length > 1;
    if (prev) prev.hidden = !many;
    if (next) next.hidden = !many;

    if (scroll && phone() && track) {
      try { track.scrollTo({ left: frame.offsetLeft, behavior: scroll }); }
      catch (e) { track.scrollLeft = frame.offsetLeft; }
    }
  }

  /* The swatch changes which colour's photographs exist on the page at all.
     Everything of another colour is hidden, which takes it out of the swipe
     track, out of the rail and out of the dot count in one move. */
  function setColour(value) {
    if (!value || value === colour) return;
    colour = value;
    gal.setAttribute('data-c2-colour', value);
    for (var n = 0; n < frames.length; n++) {
      var mine = inColour(frames[n]);
      frames[n].hidden = !mine;
      if (thumbs[n]) thumbs[n].hidden = !mine;
      if (dots[n]) dots[n].hidden = !mine;
    }
    measure();
    var list = group();
    if (list.length) show(frames.indexOf(list[0]), null);
    if (track) track.scrollLeft = 0;
    /* The rest of this colour arrives while the first frame is being looked
       at, so a swipe does not meet an empty box either. */
    idle(function () { warm(list); });
  }

  function step(by) {
    var list = group();
    if (list.length < 2) return;
    var pos = list.indexOf(frames[at]);
    if (pos < 0) pos = 0;
    pos = (pos + by + list.length) % list.length;
    show(frames.indexOf(list[pos]), 'smooth');
  }

  gal.addEventListener('click', function (e) {
    var t = e.target.closest('[data-c2-thumb]');
    if (t) { show(thumbs.indexOf(t), 'smooth'); return; }
    var d = e.target.closest('[data-c2-dot]');
    if (d) { show(dots.indexOf(d), 'smooth'); return; }
    var s = e.target.closest('[data-c2-step]');
    if (s) { step(Number(s.getAttribute('data-c2-step'))); }
  });

  if (track) {
    track.addEventListener('scroll', function () {
      if (!phone()) return;
      if (!geo.length || !geo[at] || !geo[at].w) measure();
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = -1, bestD = Infinity;
      for (var i = 0; i < frames.length; i++) {
        if (frames[i].hidden || !geo[i]) continue;
        var dd = Math.abs(geo[i].l + geo[i].w / 2 - mid);
        if (dd < bestD) { bestD = dd; best = i; }
      }
      if (best >= 0 && best !== at) show(best, null);
    }, { passive: true });
  }
  window.addEventListener('resize', measure);

  /* Which option is the colour comes from Liquid, because the cables put
     Cable length in the picker beside it and the first option is not always
     the one that changes the photographs. */
  var form = document.getElementById('c2-buy');
  var pos = Number(gal.getAttribute('data-c2-colour-pos') || 1);
  if (form) {
    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-c2-opt]')) return;
      var picked = form.querySelector('[data-c2-opt="' + pos + '"]:checked');
      if (picked) setColour(picked.value);
    });
  }

  measure();
  show(at, 'auto');

  /* After first paint, never during it. */
  idle(function () { warm(leadFrames()); });
})();

/* THE FEATURE FILM FRAME, 17 October 2026. A frame may carry a film in
   place of a photograph (data-c2-film). It is written without autoplay and
   with preload none, so it costs nothing until it is looked at: when show()
   puts it on, it is played; when another frame comes on, it is paused. On a
   phone the swipe handler calls show() as the frame centres, which is the
   same moment. Reduced motion never plays it and sees the poster, which is
   the still. */
(function () {
  var gal = document.querySelector('[data-c2-gal]');
  if (!gal) return;
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
  function settle() {
    var frames = gal.querySelectorAll('[data-c2-film]');
    for (var i = 0; i < frames.length; i++) {
      var on = frames[i].hasAttribute('data-c2-on') && !frames[i].hidden;
      var vids = frames[i].querySelectorAll('video');
      for (var k = 0; k < vids.length; k++) {
        var v = vids[k];
        /* A frame may carry two cuts, one per width; CSS displays one. */
        var shown = on && v.offsetWidth > 0;
        if (shown && !calm.matches) {
          if (v.paused) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else if (!v.paused) {
          v.pause();
        }
      }
    }
  }
  var mo = new MutationObserver(settle);
  mo.observe(gal, { attributes: true, attributeFilter: ['data-c2-on', 'hidden'], subtree: true });
  window.matchMedia('(max-width: 989px)').addEventListener('change', settle);
  settle();
})();